import React, { useState, useEffect } from 'react';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';
import { IconButton } from '@material-ui/core';
import CombinedAudioButtonLivemeeting from 'components/CombinedAudioButtonLivemeeting';
import CombinedVideoButtonLivemeeting from 'components/CombinedVideoButtonLivemeeting';
import styles from './styles';

export default function PublisherToolBar({
  setPublisherAudio,
  publisherAudio,
  publisherVideo,
  setPublisherVideo,
  room,
}) {
  const classes = styles();
  const title = publisherAudio ? 'Disable Microphone' : 'Enable Microphone';
  const videotitle = publisherVideo ? 'Disable Video' : 'Enable Video';
  const anchorRef = React.useRef(null);
  const videoRef = React.useRef(null);

  const toggleAudio = () => {
    setPublisherAudio((prev) => !prev);
  };

  const toggleVideo = () => {
    setPublisherVideo((prev) => !prev);
  };

  // For CombinedAudioButtonLivemeeting
  const changeAudioSource = (audioId) => {
    if (room && room.camera) {
      room.camera.setAudioDevice(audioId);
    }
  };

  const getAudioSource = async () => {
    if (room && room.camera) {
      const audioDevice = await room.camera.getAudioDevice();
      return audioDevice?.deviceId;
    }
  };

  const changeAudioOutput = async (audioOutputDeviceId) => {
    if (window.OT) {
      await window.OT.setAudioOutputDevice(audioOutputDeviceId);
    }
  };

  const getCurrentAudioOutput = async () => {
    try {
      if (window.OT) {
        const currentAudioOutput = await window.OT.getActiveAudioOutputDevice();
        return currentAudioOutput?.deviceId;
      }
    } catch (e) {
      return e;
    }
  };

  // For CombinedVideoButtonLivemeeting
  const getVideoSource = () => {
    if (room && room.camera) {
      return room.camera.getVideoDevice();
    }
  };

  const changeVideoSource = (videoId) => {
    if (room && room.camera) {
      room.camera.setVideoDevice(videoId);
    }
  };

  return (
    <>
      <div className={classes.toolbarContainer}>
        <div className={classes.toolbarContainerWrapper}>
          <CombinedAudioButtonLivemeeting
            toggleAudio={toggleAudio}
            hasAudio={publisherAudio}
            classes={classes}
            changeAudioSource={changeAudioSource}
            getAudioSource={getAudioSource}
            audioPublishing={publisherAudio}
            changeAudioOutput={changeAudioOutput}
            getCurrentAudioOutput={getCurrentAudioOutput}
          />

          <CombinedVideoButtonLivemeeting
            toggleVideo={toggleVideo}
            hasVideo={publisherVideo}
            classes={classes}
            getVideoSource={getVideoSource}
            cameraPublishing={publisherVideo}
            changeVideoSource={changeVideoSource}
            room={room}
          />
        </div>
      </div>
    </>
  );
}
